/**
 * Focus/open state for button-based dropdown triggers: white surface with a 2px
 * Primary Base border. The inset shadow adds the second pixel without shifting layout.
 */
export const FOCUS_BORDER = {
  borderColor: "var(--primary-base)",
  boxShadow: "inset 0 0 0 1px var(--primary-base)",
};
